import React, { useEffect, useState } from "react";
import { push } from "connected-react-router";
import Modal from "react-modal";
import { connect } from "react-redux";
import {
    Header,
    Button,
    ErrorMark,
    ErrorWithString,
    NavigationLinkButton,
    Paragraph
    // SubHeader
} from "../../components/RegularComponents";
import { applicationReviewSelect } from "../../redux/selector/applicationReviewSelector";
import BusinessContactDetail from "../AgencyLicence/BusinessContactDetail";
import AddressForService from "../AgencyLicence/AddressForService";
import AddressForFinancialRecords from "../AgencyLicence/AddressForFinancialRecords";
import LicenceHistoryDetails from "../AgencyLicence/LicenceHistoryDetails";
import CriminalHistoryDetails from "../AgencyLicence/CriminalHistoryDetails";
import WorkHistoryDetails from "../AgencyLicence/WorkHistoryDetails";
import LicenceSuspensionDetails from "../AgencyLicence/LicenceSuspensionDetails";
import AdditionalBranchDetails from "../AgencyLicence/AdditionalBranchDetails";
import CompanyTrademark from "../AgencyLicence/CompanyTrademark";
// import TrustAccount from '../AgencyLicence/TrustAccount'
import SupportingDocuments from "../AgencyLicence/SupportingDocuments";
import TopNavigationBar from "../TopNavigationBar";
import {
    // APPLICATION_MODE_NEW,
    APPLICATION_MODE_RENEW,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    DOCUMENT_CONTENT_TYPE_PDF,
    REQUEST_STATUS,
    ROUTE_PATH,
    DOCUMENT_TYPE_FORMS_AGREEMENTS,
    individualFileSizeAllowedInMB,
    DOCUMENT_TYPE_SURETY_BONDS
} from "../../app/constants";
import Navigation from "../Navigation";
import {
    areContactObjectSame,
    combineAddress,
    fullName,
    humanReadableDate,
    replaceUrlParams,
    ValidateString
} from "../../app/utils";
import ReviewForm from "../../components/ReviewForm/ReviewForm";
import DocumentViewer from "../../components/DocumentViewer/DocumentViewer";
import {
    DocumentViewerFileNameLink,
    DownloadFileNameLink
} from "../../components/DocumentViewer/DocumentFileComponent";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from "../../app/errors";
import {
    acceptedFileFormats,
    convertFileDataForUrl,
    extractBase64,
    fileNameWithLengthLimit,
    fileTypeEnum,
    validateFileName
} from "../../app/documentUploadUtils";
import { fetchDocumentData } from "../../redux/slice/supportingDocumentsSlice";
import {
    setMortgageProperty,
    setAgencySupportingDocuments
} from "../../redux/slice/primaryAgencyApplicationSlice";
import CheckBoxForm from "../../components/CheckBoxForm";
import { setAllNewBranchApplicationsProperty } from "../../redux/slice/additionalApplicationsSlice";
import { MraRJSCEnterCompanyInfo } from "../MRA/MraRJSCEnterCompanyInfo";
import { MraRJSCEnterCompanyOfficals } from "../MRA/MraRJSCEnterCompanyOfficials";
// import CheckBoxForm from '../../components/CheckBoxForm';

const AGENT_APPLICATION_PROPERTY = "userApplicationReviewComplete";

const REVIEW_COMPONENT_KEYS = {
    RJSC_COMPANY_INFO: "rjscCompanyInfo",
    RJSC_COMPANY_OFFICIALS: "rjscCompanyOfficials",
    BUSINESS_CONTACT: "businessContact",
    ADDRESS_FOR_SERVICE: "addressForService",
    ADDRESS_FOR_FINANCE: "addressForFinance",
    CRIMINAL_HISTORY: "criminalHistoryDetails",
    WORK_HISTORY: "workHistoryDetails",
    LICENCE_SUSPENSION: "licenceSuspensionDetails",
    ADDITIONAL_BRANCHES: "additionalBranches",
    SUPPORTING_DOCUMENTS: "supportingDocuments",
    COMPANY_TRADEMARK: "companyTrademark"
};

const ApplicationRenewalReview = (props) => {
    const { applicationReview, dispatch } = props;
    const { applicationType, applicationMode } = props.match.params;
    const { forChangeRequest } = props.location.state ?? false;
    const [reviewDetails, setReviewDetails] = useState(applicationReview.reviewDetails);
    const [suretyBondFiles, setSuretyBondFiles] = useState([]);
    const [validationError, setValidationError] = useState(false);
    const [componentValidation, setComponentValidation] = useState({});

    useEffect(() => {
        setReviewDetails(applicationReview.reviewDetails);
    }, [applicationReview.reviewDetails, setReviewDetails]);

    const [editComponent, setEditComponent] = useState(null);
    const [showEditDialog, setShowEditDialog] = useState(false);

    const [openDocumentViewer, setOpenDocumentViewer] = useState(false);
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [applicationSaveError, setApplicationSaveError] = useState(false);

    const companyRjscDetails = applicationReview?.companyRjscDetails;
    const notRegistered = !companyRjscDetails?.businessEntity?.entityId;

    const { businessEntity, businessData, businessContact, status } = companyRjscDetails;

    let RJSCCompanyInfoLabels,  RJSCCompanyInfoValues= null;
    if (notRegistered) {
        RJSCCompanyInfoLabels = [
            "Legal Business Name",
            "Operating Name",
            "Trade Mark",
            "Registered Office"
        ];
        RJSCCompanyInfoValues = [
            `${businessData?.businessOwner ?? applicationReview?.businessName}`,
            `${businessData?.businessOwner ? businessEntity?.businessName : "---"}`,
            applicationReview?.companyTrademark ? applicationReview.companyTrademark : "<i>N/A</i>",
            `${combineAddress(businessContact?.civicAddress)}`
        ];
    } else {
        RJSCCompanyInfoLabels = [
            "Legal Business Name",
            "Operating Name",
            "Trade Mark",
            "RJSC Number",
            "RJSC Status",
            "Registered Office"
        ];
        RJSCCompanyInfoValues = [
            `${businessData?.businessOwner ?? applicationReview?.businessName}`,
            `${businessData?.businessOwner ? businessEntity?.businessName : ""}`,
            applicationReview?.companyTrademark ? applicationReview.companyTrademark : "<i>N/A</i>",
            `${businessData?.relatedTo ?? businessEntity?.registryNumber}`,
            `${status}`,
            `${combineAddress(businessContact?.civicAddress)}`
        ];
    }

    const MainSeparator = () => {
        return (
            <hr className="bottomMarginNormal" style={{ borderColor: "#777", borderWidth: "3px" }} />
        );
    };

    const SubSeparator = () => {
        return (
            <hr
                className="bottomMarginNormal"
                style={{
                    borderColor: "#0058a466",
                    borderWidth: "3px",
                    width: "60%",
                    marginLeft: "0px"
                }}
            />
        );
    };

    /*=== click handlers == */
    const handleEditRJSCCompanyInfo = () => {
        setShowEditDialog(true);
        setEditComponent(REVIEW_COMPONENT_KEYS.RJSC_COMPANY_INFO);
    };

    const handleEditRJSCCompanyOfficial = () => {
        setShowEditDialog(true);
        setEditComponent(REVIEW_COMPONENT_KEYS.RJSC_COMPANY_OFFICIALS);
    };

    const handleEditBusinessContact = () => {
        setShowEditDialog(true);
        setEditComponent(REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT);
    };

    const handleEditAddressForService = () => {
        setShowEditDialog(true);
        setEditComponent(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE);
    };

    const handleEditAddressForFinance = () => {
        setShowEditDialog(true);
        setEditComponent(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE);
    };

    const handleCriminalHistoryListEdit = () => {
        setShowEditDialog(true);
        setEditComponent(REVIEW_COMPONENT_KEYS.CRIMINAL_HISTORY);
    };

    const handleLicenceSuspendedEdit = () => {
        setShowEditDialog(true);
        setEditComponent(REVIEW_COMPONENT_KEYS.LICENCE_SUSPENSION);
    };

    const handleAdditionalBranchesEdit = () => {
        setShowEditDialog(true);
        setEditComponent(REVIEW_COMPONENT_KEYS.ADDITIONAL_BRANCHES);
    };

    const handleSupportingDocumentsEdit = () => {
        setShowEditDialog(true);
        setEditComponent(REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS);
    };

    /* */
    const convertSupportingDocumentDataComponentsForReview = (data) => {
        if (!data) {
            return null;
        }

        let reviewData = {};

        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                const files = data[key];
                const fileComponents = [];

                if (files && Array.isArray(files)) {
                    files?.forEach((file, index) => {
                        if (file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF) {
                            fileComponents.push(
                                <div style={{ maxWidth: "40rem", overflow: "hidden" }}>
                                    <DocumentViewerFileNameLink
                                        id={"document-view-link-" + file.fileName}
                                        key={"document-view-link-" + file.fileName}
                                        file={file}
                                        onClick={() => {
                                            if (file.data) {
                                                let fileDataUrl = convertFileDataForUrl(
                                                    file.data,
                                                    file.documentContentType
                                                );
                                                setDocumentViewerDocument(fileDataUrl);
                                                setSelectedFile(file);
                                                setOpenDocumentViewer(true);
                                            } else {
                                                dispatch(fetchDocumentData(file.guid))
                                                    .then((downloadFile) => {
                                                        if (downloadFile) {
                                                            let fileDataUrl = convertFileDataForUrl(
                                                                downloadFile.data,
                                                                downloadFile.documentContentType
                                                            );
                                                            setDocumentViewerDocument(fileDataUrl);
                                                            setOpenDocumentViewer(true);
                                                            setSelectedFile(downloadFile);
                                                        }
                                                    })
                                                    .catch((error) => {
                                                        console.error(error);
                                                    });
                                            }
                                        }}
                                    />
                                </div>
                            );
                        } else {
                            fileComponents.push(
                                <DownloadFileNameLink
                                    id={"download-link-" + file.fileName}
                                    componentKey={"download-link-" + file.fileName}
                                    file={file}
                                />
                            );
                        }

                        if (file.createdDate) {
                            const dateStr = humanReadableDate(file.createdDate);
                            fileComponents.push(
                                <div style={{ paddingLeft: "5px", color: "gray" }}>Uploaded on {dateStr}</div>
                            );
                        }

                        if (index < files.length - 1) {
                            fileComponents.push(<br />);
                        }
                    });
                }

                Object.defineProperty(reviewData, key, {
                    value: fileComponents,
                    writable: true,
                    enumerable: true
                });
            }
        }

        return reviewData;
    };

    const isSuretyBondDocumentValid = () => {
        // if(showValidationError) {
        //     return (formsValidationError === VALIDATION_ERROR.NO_ERROR)
        // }

        return true;
    };

    const fileSizeReplacement = (string, fileSize) => {
        const replaceRegExp = /<file_size>/g;
        const errorString = string.replace(replaceRegExp, fileSize + "MB");
        return errorString;
    };

    const onSuretyBondFileInputChange = (e) => {
        if (e.target.files.length > 0) {
            let file = e.target.files[0];

            // individual file size can not be more than 15 MB
            if (file.size > individualFileSizeAllowedInMB * 2 ** 20) {
                alert(
                    fileSizeReplacement(
                        ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE,
                        individualFileSizeAllowedInMB
                    )
                );
                return;
            } else if (!validateFileName(file.name)) {
                alert("File name is not valid. Please select another file.");
                return;
            }

            let reader = new FileReader();
            reader.onload = (readerData) => {
                setSuretyBondFiles([
                    ...suretyBondFiles,
                    {
                        filename: fileNameWithLengthLimit(file.name),
                        documentContentType: fileTypeEnum(file.type),
                        data: extractBase64(readerData.target.result),
                        changeType: "SAVE",
                        documentType: DOCUMENT_TYPE_SURETY_BONDS,
                        fileSize: file.size
                    }
                ]);
            };
            reader.readAsDataURL(file);
        }
    };

    const fileComponent = (id, file, index) => {
        return (
            <>
                <div className="col-8 supportingDocumentsFileContentWrapper">
                    <span className="fileName">
                        {file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? (
                            <DocumentViewerFileNameLink
                                id={"supporting-document-view-file-" + file.filename}
                                key={"supporting-document-view-file-" + file.filename}
                                file={file}
                                onClick={() => {
                                    if (file.data) {
                                        let fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType);
                                        setDocumentViewerDocument(fileDataUrl);
                                        setOpenDocumentViewer(true);
                                        setSelectedFile(file);
                                    } else {
                                        // download data and then view it.
                                        if (file.guid) {
                                            dispatch(fetchDocumentData(file.guid))
                                                .then((downloadFile) => {
                                                    if (downloadFile) {
                                                        let fileDataUrl = convertFileDataForUrl(
                                                            downloadFile.data,
                                                            downloadFile.documentContentType
                                                        );
                                                        setDocumentViewerDocument(fileDataUrl);
                                                        setOpenDocumentViewer(true);
                                                        setSelectedFile(downloadFile);
                                                    }
                                                })
                                                .catch((error) => {
                                                    console.error(error);
                                                });
                                        }
                                    }
                                }}
                            />
                        ) : (
                            <DownloadFileNameLink
                                id={"supporting-document-download-file-" + file.filename}
                                componentKey={"supporting-document-download-file-" + file.filename}
                                file={file}
                            />
                        )}
                    </span>

                    <NavigationLinkButton
                        id={id + "-remove-link"}
                        text={"- Remove this file"}
                        onClick={() => {
                            let updatedFiles = [...suretyBondFiles];

                            let file = updatedFiles[index];

                            if (file.guid) {
                                updatedFiles.splice(index, 1, Object.assign({}, file, { changeType: "DELETE" }));
                            } else {
                                updatedFiles.splice(index, 1);
                            }

                            setSuretyBondFiles(updatedFiles);
                        }}
                    />
                </div>

                <DocumentViewer
                    fileData={documentViewerDocument}
                    isOpen={openDocumentViewer}
                    fileName={selectedFile?.filename}
                    handleClose={() => setOpenDocumentViewer(false)}
                />
            </>
        );
    };

    const suretyBondFilesComponent = () => {
        let components = [];
        suretyBondFiles.forEach((file, index) => {
            if (file.changeType !== "DELETE") {
                components.push(fileComponent("surety-bond-files-components", file, index));
            }
        });

        return components;
    };

    const titleForComponent = (componentKey) => {
        switch (componentKey) {
            case REVIEW_COMPONENT_KEYS.RJSC_COMPANY_INFO:
                return "Enter Company Information";
            case REVIEW_COMPONENT_KEYS.RJSC_COMPANY_OFFICIALS:
                return "Enter Company Offical Information";
            case REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT:
                return "Business contact for licensing inquiries and consumer complaints and compliance";
            case REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE:
                return "Address for service";
            case REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE:
                return "Address for financial records";
            case REVIEW_COMPONENT_KEYS.CRIMINAL_HISTORY:
                return "Criminal history details";
            case REVIEW_COMPONENT_KEYS.WORK_HISTORY:
                return "Work history";
            case REVIEW_COMPONENT_KEYS.LICENCE_SUSPENSION:
                return "Licence suspension";
            case REVIEW_COMPONENT_KEYS.ADDITIONAL_BRANCHES:
                return "Additional branches";
            case REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS:
                return "Supporting documents";
            case REVIEW_COMPONENT_KEYS.COMPANY_TRADEMARK:
                return "Company trademark";
            default:
                return "";
        }
    };

    const validateBusinessContact = () => {
        const { mainBusinessContact, complianceOfficer, responsibleAgent } = applicationReview;

        const validateBlock = (data) => {
            if (ValidateString(data?.firstName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
                return false;
            else if (ValidateString(data?.lastName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
                return false;
            else if (
                ValidateString(data?.phoneNumber, VALIDATION_TYPE.PHONE_NUMBER) !==
                VALIDATION_ERROR.NO_ERROR
            )
                return false;
            else if (
                ValidateString(data?.emailAddress, VALIDATION_TYPE.EMAIL) !== VALIDATION_ERROR.NO_ERROR
            )
                return false;

            return true;
        };

        const ret1 = validateBlock(mainBusinessContact);
        const ret2 = validateBlock(complianceOfficer);
        const ret3 = validateBlock(responsibleAgent);

        if (!ret1 || !ret2 || !ret3) {
            const components = [];
            if (!ret1) {
                components.push("business contact");
            }
            if (!ret2) {
                components.push("compliance officer");
            }
            if (!ret3) {
                components.push("responsible agent");
            }

            setComponentValidation((obj) => {
                let validationObj = { ...obj };
                validationObj[REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT] = {
                    validationFailure: true,
                    errorString: `Please complete ${components.join(" and ")} details`
                };
                return validationObj;
            });
        } else {
            setComponentValidation((obj) => {
                let validationObj = { ...obj };
                validationObj[REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT] = {
                    validationFailure: false,
                    errorString: null
                };
                return validationObj;
            });
        }

        return ret1 && ret2 && ret3;
    };

    const validateAddress = (address, componentKey) => {
        let ret = true;

        if (!address) {
            ret = false;
        } else {
            const { city, postalCode, street } = address;

            if (!city || !postalCode || !street) {
                ret = false;
            }
        }

        if (!ret) {
            setComponentValidation((obj) => {
                let validationObj = { ...obj };
                validationObj[componentKey] = {
                    validationFailure: true,
                    errorString: `Please complete address details`
                };
                return validationObj;
            });
        } else {
            setComponentValidation((obj) => {
                let validationObj = { ...obj };
                validationObj[componentKey] = {
                    validationFailure: false,
                    errorString: null
                };
                return validationObj;
            });
        }

        return ret;
    };

    const validateSupportingDocuments = () => {
        const { supportingDocuments } = reviewDetails;

        // reviewDetails.supportingDocuments.map
        const components = [];
        let validationFailure = false;
        supportingDocuments.forEach((docs) => {
            for (const key in docs) {
                const files = docs[key];
                if (!files?.length) {
                    validationFailure = true;
                    components.push(key.toLowerCase());
                }
            }
        });

        if (validationFailure) {
            setComponentValidation((obj) => {
                let validationObj = { ...obj };
                validationObj[REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS] = {
                    validationFailure,
                    errorString: `Please upload supporting documents for ${components.join(" and ")}`
                };
                return validationObj;
            });
        } else {
            setComponentValidation((obj) => {
                let validationObj = { ...obj };
                validationObj[REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS] = {
                    validationFailure,
                    errorString: null
                };
                return validationObj;
            });
        }

        return !validationFailure;
    };

    const checkValidation = () => {
        const ret1 = validateBusinessContact();

        const { serviceCivicAddress, financialRecordsLocation } = applicationReview;

        const ret2 = validateAddress(serviceCivicAddress, REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE);
        const ret3 = validateAddress(
            financialRecordsLocation,
            REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE
        );
        const ret4 = validateSupportingDocuments();

        return ret1 && ret2 && ret3 && ret4;
    };

    const isValidationFailure = (componentKey) => {
        if (
            componentValidation &&
            componentValidation[componentKey] &&
            componentValidation[componentKey]["validationFailure"]
        ) {
            return componentValidation[componentKey]["validationFailure"];
        }

        return false;
    };

    const validationFailureErrorString = (componentKey) => {
        if (
            componentValidation &&
            componentValidation[componentKey] &&
            componentValidation[componentKey]["errorString"]
        ) {
            return componentValidation[componentKey]["errorString"];
        }

        return "Please complete all fields for this section.";
    };

    /* == render == */
    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <TopNavigationBar {...props} hideSaveAndExit={forChangeRequest} />
                {forChangeRequest ? (
                    <div className="row topMarginMedium bottomMarginMedium">
                        <div className="col-lg-12 reviewHeader">
                            <span>{applicationReview?.businessName ?? ""}</span>
                        </div>
                        <div className="col-lg-12 reviewSubHeader">
                            <span>
                                {applicationReview?.companyRjscDetails?.businessData?.businessOwner ?? ""}
                            </span>
                        </div>
                    </div>
                ) : (
                    <Header header={applicationReview.header} />
                )}

                <div className="timeline row bottomMarginMedium">
                    <ol>
                        <li className="timeline-item_deprecated col-md-12">
                            <div className="step-conten_deprecated col-md-12 col-xs-12">
                                {/* <MainSeparator /> */}

                                <div className="row">
                                    <div className="col-lg-11">
                                        <h3>Company Information</h3>
                                    </div>
                                    <div className="col-lg-1">
                                        {notRegistered && (
                                            <Button
                                                style={{ marginTop: "10px" }}
                                                buttonType={"regular_primary"}
                                                text={"Edit"}
                                                onClick={handleEditRJSCCompanyInfo}
                                            />
                                        )}
                                    </div>
                                </div>
                                {/* {Should be taken from the RJSC slice?} */}
                                <div className="row">
                                    <div className="col-lg-3">
                                        <Paragraph
                                            id="broker-application-review-text"
                                            text={RJSCCompanyInfoLabels}
                                        />
                                    </div>
                                    <div className="col-lg-9">
                                        <Paragraph
                                            id="broker-application-review-text"
                                            text={RJSCCompanyInfoValues}
                                        />
                                    </div>
                                </div>
                                <SubSeparator />
                                <div className="row">
                                    <div className="col-lg-12">
                                        <Paragraph
                                            style={{ paddingTop: "10px" }}
                                            id="broker-application-review-text"
                                            text={[`<h4>Officals listed ${notRegistered ? "" : "under RJSC"} ?</h4>`]}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {businessData?.peopleList?.map((person, index) => (
                                            <>
                                                <div className="row">
                                                    <div className="col-lg-3">
                                                        <Paragraph
                                                            id="broker-application-review-text"
                                                            text={["Name", "Relationship"]}
                                                        />
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <Paragraph
                                                            id="broker-application-review-text"
                                                            text={[fullName(person), person.position]}
                                                        />
                                                    </div>
                                                </div>
                                                {index < businessData?.peopleList?.length - 1 && <SubSeparator />}
                                            </>
                                        ))}
                                    </div>
                                    <div className="col-lg-1">
                                        {notRegistered && (
                                            <Button
                                                style={{ marginTop: "10px" }}
                                                buttonType={"regular_primary"}
                                                text={"Edit"}
                                                onClick={handleEditRJSCCompanyOfficial}
                                            />
                                        )}
                                    </div>
                                </div>
                                <MainSeparator />
                            </div>
                        </li>

                        <li className="timeline-item_deprecated col-md-12">
                            <div className="step-conten_deprecated t col-md-12 col-xs-12">
                                <div className="row">
                                    <div className="col-lg-11">
                                        <h3>Business contact for licensing inquiries</h3>
                                        <ReviewForm data={reviewDetails.businessContact} />
                                        <div className="topMarginMedium">
                                            <h3>Business contact for consumer complaints and compliance</h3>
                                            {areContactObjectSame(
                                                reviewDetails.businessContact,
                                                reviewDetails.complianceOfficer
                                            ) ? (
                                                <CheckBoxForm
                                                    id={"business-contact-checkbox"}
                                                    value={"business-compliance-same"}
                                                    labelText={"Same as contact for licensing inquiries"}
                                                    onCheckBoxChange={handleEditBusinessContact}
                                                    checked={true}
                                                />
                                            ) : (
                                                <ReviewForm data={reviewDetails.complianceOfficer} />
                                            )}
                                        </div>
                                        <div className="topMarginMedium">
                                            <h3>Responsible agent</h3>
                                            {areContactObjectSame(
                                                reviewDetails.businessContact,
                                                reviewDetails.responsibleAgent
                                            ) ? (
                                                <CheckBoxForm
                                                    id={"business-contact-checkbox"}
                                                    value={"business-compliance-same"}
                                                    labelText={"Same as contact for licensing inquiries"}
                                                    onCheckBoxChange={handleEditBusinessContact}
                                                    checked={true}
                                                />
                                            ) : (
                                                <ReviewForm data={reviewDetails.responsibleAgent} />
                                            )}
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            "col-lg-1" + isValidationFailure(REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT)
                                                ? " has-error"
                                                : ""
                                        }
                                    >
                                        <Button
                                            id="edit-business-contact"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleEditBusinessContact}
                                        />
                                        {isValidationFailure(REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT) && ErrorMark()}
                                    </div>
                                    {isValidationFailure(REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT) && (
                                        <div className="col-lg-8 help-block topMarginNormal has-error">
                                            <big>{`* ${validationFailureErrorString(REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT)}`}</big>
                                        </div>
                                    )}
                                </div>
                                <MainSeparator />
                                <div className="row">
                                    <div className="col-lg-11">
                                        <h3>{titleForComponent(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE)}</h3>
                                        <ReviewForm data={reviewDetails.addressForService} />
                                    </div>
                                    <div
                                        className={
                                            "col-lg-1" + isValidationFailure(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE)
                                                ? " has-error"
                                                : ""
                                        }
                                    >
                                        <Button
                                            id="edit-address-for-service"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleEditAddressForService}
                                        />
                                        {isValidationFailure(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE) && ErrorMark()}
                                    </div>
                                    {isValidationFailure(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE) && (
                                        <div className="col-lg-8 help-block topMarginNormal has-error">
                                            <big>{`* ${validationFailureErrorString(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE)}`}</big>
                                        </div>
                                    )}
                                </div>
                                <MainSeparator />
                                <div className="row">
                                    <div className="col-lg-11">
                                        <h3>{titleForComponent(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE)}</h3>
                                        <ReviewForm data={reviewDetails.addressForFinance} />
                                    </div>
                                    <div
                                        className={
                                            "col-lg-1" + isValidationFailure(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE)
                                                ? " has-error"
                                                : ""
                                        }
                                    >
                                        <Button
                                            id="edit-address-for-finance"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleEditAddressForFinance}
                                        />
                                        {isValidationFailure(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE) && ErrorMark()}
                                    </div>
                                    {isValidationFailure(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE) && (
                                        <div className="col-lg-8 help-block topMarginNormal has-error">
                                            <big>{`* ${validationFailureErrorString(REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE)}`}</big>
                                        </div>
                                    )}
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item_deprecated col-md-12">
                            <div className="step-conten_deprecated col-md-12 col-xs-12">
                                <h3>Criminal history details</h3>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {reviewDetails.criminalHistoryListData.length === 0 ? (
                                            <p>
                                                If any of your directors, partners or officers were convicted of an offence
                                                for which they have not been pardoned since your last renewal, update this
                                                information here.
                                            </p>
                                        ) : (
                                            reviewDetails.criminalHistoryListData.map((criminalData, index) => {
                                                return (
                                                    <div key={"criminal-history-data-" + index}>
                                                        <ReviewForm data={criminalData} />
                                                        {index < reviewDetails.criminalHistoryListData.length - 1 && (
                                                            <SubSeparator />
                                                        )}
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                    <div className="col-lg-1 col-md-2 col-xs-2">
                                        <Button
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleCriminalHistoryListEdit}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item_deprecated col-md-12">
                            <div className="step-conten_deprecated t col-md-12 col-xs-12">
                                {/* <span className="step-counter step-counter-circle">3</span> */}
                                <h3>Licence suspension</h3>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {reviewDetails.licenceSuspendedData.length === 0 ? (
                                            <p>
                                                If your company had a business licence refused, suspended or revoked in Nova
                                                Scotia or another province since your last renewal, update this information
                                                here.
                                            </p>
                                        ) : (
                                            <>
                                                <ReviewForm data={reviewDetails.licenceSuspendedQuestion} />
                                                {reviewDetails.licenceSuspendedData.map((data, index) => {
                                                    return (
                                                        <div key={"suspension-data" + index}>
                                                            <ReviewForm data={data} />
                                                            {index < reviewDetails.licenceSuspendedData.length - 1 && (
                                                                <SubSeparator />
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-licence-suspended"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleLicenceSuspendedEdit}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item_deprecated col-md-12">
                            <div className="step-conten_deprecated t col-md-12 col-xs-12">
                                {/* <span className="step-counter step-counter-circle">4</span> */}
                                <h3>Additional branches</h3>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {reviewDetails.additionalBranches.length === 0 ? (
                                            <>
                                                <p>
                                                    To renew your branches, click the Edit button and enter your branch
                                                    information. You don't need to enter information for branches you aren't
                                                    renewing.
                                                </p>
                                                <p>You don't need to enter information about your main office.</p>
                                            </>
                                        ) : (
                                            reviewDetails.additionalBranches.map((data, index) => {
                                                return (
                                                    <div key={"additional-banch-data-" + index}>
                                                        <ReviewForm data={data} />
                                                        {index < reviewDetails.additionalBranches.length - 1 && (
                                                            <SubSeparator />
                                                        )}
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                    <div className="col-lg-1">
                                        <Button
                                            id="edit-additional-branches"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleAdditionalBranchesEdit}
                                        />
                                    </div>
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item_deprecated col-md-12">
                            <div className="step-conten_deprecated t step-conten_deprecated t-no-border col-md-12 col-xs-12">
                                {/* <span className="step-counter step-counter-circle">5</span> */}
                                <h3>Supporting documents</h3>
                                <p>
                                    Review your previously submitted documents. If any documents your agency uses to
                                    enter an agreement with debtors changed or you have new letters or notices you use
                                    with clients, upload the new documents here.
                                </p>
                                <div className="row">
                                    <div className="col-lg-11">
                                        {reviewDetails.supportingDocuments.map((data, index) => {
                                            const reviewData = convertSupportingDocumentDataComponentsForReview(data);

                                            return (
                                                <div key={"supporting-docs-data-" + index}>
                                                    <ReviewForm data={reviewData} fullSize={true} />
                                                    {index < reviewDetails.supportingDocuments.length - 1 && <SubSeparator />}
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div
                                        className={
                                            "col-lg-1" + isValidationFailure(REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS)
                                                ? " has-error"
                                                : ""
                                        }
                                    >
                                        <Button
                                            id="edit-supporting-documents"
                                            buttonType="regular_primary"
                                            text="Edit"
                                            onClick={handleSupportingDocumentsEdit}
                                        />
                                        {isValidationFailure(REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS) && ErrorMark()}
                                    </div>
                                    {isValidationFailure(REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS) && (
                                        <div className="col-lg-8 help-block topMarginNormal has-error">
                                            <big>{`* ${validationFailureErrorString(REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS)}`}</big>
                                        </div>
                                    )}
                                </div>
                                <MainSeparator />
                            </div>
                        </li>
                        <li className="timeline-item_deprecated col-md-12">
                            <div className="step-conten_deprecated t step-conten_deprecated t-no-border col-md-12 col-xs-12">
                                {/* <span className="step-counter step-counter-circle">5</span> */}
                                <h3>Surety bond</h3>
                                <p>
                                    And original surety bond is already on file with Business Licensing. If any of
                                    your bond information has changed, upload supporting documentation here.
                                </p>
                                <div className="row">{suretyBondFilesComponent()}</div>
                                <div className="row">
                                    <div className="col-lg-8">
                                        <fieldset className="ns-fieldset" id="suretybond-documents-forms-form">
                                            <div
                                                className={
                                                    "ns-fieldset" +
                                                    (!isSuretyBondDocumentValid() ? " ns-fieldset-message-error" : "")
                                                }
                                            >
                                                <label
                                                    className="ns-label"
                                                    id="suretybond-document-forms-file-label"
                                                    htmlFor="suretybond-document-forms-file-input"
                                                >
                                                    Upload a file
                                                </label>
                                                {!isSuretyBondDocumentValid() && (
                                                    <span
                                                        id="suretybond-document-forms-file-input-error"
                                                        className="ns-error-message form-validation-error topMarginNormal"
                                                    >
                                                        {ErrorWithString(ERROR_STRING.SUPPORTING_DOC_MISSING_FORM)}
                                                    </span>
                                                )}
                                                <div className="ns-file-input">
                                                    <input
                                                        style={{ width: "15em", display: "inline" }}
                                                        type="file"
                                                        className={isSuretyBondDocumentValid() ? "ns-input" : "ns-input--error"}
                                                        accept={acceptedFileFormats(DOCUMENT_TYPE_FORMS_AGREEMENTS).join(",")}
                                                        value=""
                                                        id="suretybond-document-forms-file-input"
                                                        name="suretybond-document-forms-file-input"
                                                        multiple={false}
                                                        onChange={onSuretyBondFileInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="help-block topMarginNormal">
                                                The maximum file size allowed is 15MB per file and 50MB total. Supporting
                                                document types are Microsoft Office Word, Microsoft Office Excel or Adobe
                                                PDF. All digital files must be in an uncompressed format, i.e. no Zip or ARC
                                                files
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ol>
                </div>
                <div className="row bottomMarginMedium">
                    {!forChangeRequest ? (
                        <div
                            className={"col-lg-4" + (applicationSaveError || validationError ? " has-error" : "")}
                        >
                            <Button
                                showSpinner={
                                    !applicationSaveError &&
                                    !validationError &&
                                    applicationReview.applicationSavingRequestStatus === REQUEST_STATUS.IN_PROGRESS
                                }
                                id="save-business-licence-application-data"
                                buttonType="regular_primary"
                                text={"Save and next"}
                                onClick={() => {
                                    if (!checkValidation()) {
                                        setValidationError(true);
                                        return;
                                    }

                                    setApplicationSaveError(false);

                                    /* 
                                                  - The name might be misleading, but below function will save the 
                                                  said property for the primary agency application.
                                                  */
                                    dispatch(
                                        setMortgageProperty({
                                            key: AGENT_APPLICATION_PROPERTY,
                                            value: true
                                        })
                                    );

                                    dispatch(
                                        setAgencySupportingDocuments([
                                            ...applicationReview.supportingDocumentsRawData,
                                            ...suretyBondFiles.map((f) => {
                                                if (f.fileSize) delete f.fileSize;
                                                return f;
                                            })
                                        ])
                                    );

                                    dispatch(
                                        setAllNewBranchApplicationsProperty({
                                            key: "userApplicationReviewComplete",
                                            value: true
                                        })
                                    );

                                    props
                                        .dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
                                        .then((data) => {
                                            let nextUrl = applicationReview.navigation.next;
                                            if (applicationMode === APPLICATION_MODE_RENEW) {
                                                nextUrl = applicationReview.navigationRenewal.next;
                                            }
                                            dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)));
                                        })
                                        .catch((err) => {
                                            setApplicationSaveError(true);
                                        });
                                }}
                            />
                            {(applicationSaveError || validationError) && ErrorMark()}
                            {applicationSaveError && (
                                <div className="help-block topMarginNormal">
                                    {ERROR_STRING.APPLICATION_SAVE_ERROR}
                                </div>
                            )}
                            {validationError && (
                                <div className="help-block topMarginNormal">
                                    {ERROR_STRING.RENEWAL_APPLICATION_REVIEW_VALIDATION_ERROR}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                            <Button
                                showSpinner={
                                    !applicationSaveError &&
                                    applicationReview.applicationSavingRequestStatus === REQUEST_STATUS.IN_PROGRESS
                                }
                                text={
                                    applicationMode === APPLICATION_MODE_RENEW
                                        ? "Submit renewal request"
                                        : "Submit change request"
                                }
                                buttonType="regular_primary"
                                onClick={() => {
                                    setApplicationSaveError(false);
                                    props
                                        .dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
                                        .then((data) => {
                                            dispatch(
                                                push(replaceUrlParams(ROUTE_PATH.WELCOME, applicationType, applicationMode))
                                            );
                                        })
                                        .catch((err) => {
                                            setApplicationSaveError(true);
                                        });
                                }}
                                id="submit-change-request-button"
                            />
                            {applicationSaveError && ErrorMark()}
                            {applicationSaveError && (
                                <div className="help-block topMarginNormal">
                                    {ERROR_STRING.APPLICATION_SAVE_ERROR}
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <Modal
                    appElement={document.getElementById("root")}
                    isOpen={showEditDialog}
                    contentLabel="editDetailsDialog"
                    onRequestClose={() => {
                        setShowEditDialog(false);
                    }}
                    shouldCloseOnEsc={false}
                    shouldCloseOnOverlayClick={false}
                    className="modalDialogContent editDetailsModalDialog"
                    closeTimeoutMS={150}
                >
                    <div className="row">
                        <div className="col-11">
                            <div className="row">
                                <div className="col-12">
                                    <h2>{titleForComponent(editComponent)}</h2>
                                    <MainSeparator />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    {editComponent === REVIEW_COMPONENT_KEYS.RJSC_COMPANY_INFO && (
                                        <MraRJSCEnterCompanyInfo
                                            isModal
                                            viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                            onEditSave={() => setShowEditDialog(false)}
                                            {...props}
                                        />
                                    )}

                                    {editComponent === REVIEW_COMPONENT_KEYS.RJSC_COMPANY_OFFICIALS && (
                                        <MraRJSCEnterCompanyOfficals
                                            isModal
                                            viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                            onEditSave={() => setShowEditDialog(false)}
                                            {...props}
                                        />
                                    )}

                                    {editComponent === REVIEW_COMPONENT_KEYS.BUSINESS_CONTACT && (
                                        <BusinessContactDetail
                                            viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                            onEditSave={() => setShowEditDialog(false)}
                                            {...props}
                                        />
                                    )}
                                    {editComponent === REVIEW_COMPONENT_KEYS.ADDRESS_FOR_SERVICE && (
                                        <>
                                            <AddressForService
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    )}
                                    {editComponent === REVIEW_COMPONENT_KEYS.ADDRESS_FOR_FINANCE && (
                                        <>
                                            <AddressForFinancialRecords
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    )}
                                    {editComponent === "licenceHistoryDetails" && (
                                        <>
                                            <LicenceHistoryDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    )}
                                    {editComponent === REVIEW_COMPONENT_KEYS.CRIMINAL_HISTORY && (
                                        <>
                                            <CriminalHistoryDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    )}
                                    {editComponent === REVIEW_COMPONENT_KEYS.WORK_HISTORY && (
                                        <>
                                            <WorkHistoryDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    )}
                                    {editComponent === REVIEW_COMPONENT_KEYS.LICENCE_SUSPENSION && (
                                        <>
                                            <LicenceSuspensionDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    )}
                                    {editComponent === REVIEW_COMPONENT_KEYS.ADDITIONAL_BRANCHES && (
                                        <>
                                            <AdditionalBranchDetails
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    )}
                                    {/* {editComponent === "trustAccount" && 
                                            <>
                                                <TrustAccount 
                                                    viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT} 
                                                    onEditSave={() => setShowEditDialog(false)}
                                                    {...props}
                                                />
                                            </>
                                        } */}
                                    {editComponent === REVIEW_COMPONENT_KEYS.SUPPORTING_DOCUMENTS && (
                                        <>
                                            <SupportingDocuments
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    )}
                                    {editComponent === REVIEW_COMPONENT_KEYS.COMPANY_TRADEMARK && (
                                        <>
                                            <CompanyTrademark
                                                viewMode={VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT}
                                                onEditSave={() => setShowEditDialog(false)}
                                                {...props}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-1">
                            <div
                                className="closeButton pull-right"
                                onClick={() => {
                                    setShowEditDialog(false);
                                }}
                            >
                                <i className="fa fa-2x fa-times"></i>
                            </div>
                        </div>
                    </div>
                </Modal>

                <DocumentViewer
                    fileData={documentViewerDocument}
                    fileName={selectedFile?.filename}
                    isOpen={openDocumentViewer}
                    handleClose={() => setOpenDocumentViewer(false)}
                />
            </div>
        </>
    );
};

export default connect(applicationReviewSelect)(ApplicationRenewalReview);
